import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {AndroidIcon, IphoneIcon, BackendIcon, CPAppIcon} from "../../../app-constants";

const StackItem = [
    {
        icon: IphoneIcon,
        title: 'iOS App Development',
        description: 'SwiftLint, Objective-C, RxSwift, CircleCI, Swift, SwiftUI, CocoaPods.',
    },
    {
        icon: AndroidIcon,
        title: 'Android App Development',
        description: 'Java, Kotlin, Fastlane, Gradle, Coroutines, Dagger2, JetPack.',
    },
    {
        icon: CPAppIcon,
        title: 'Cross-platform App Development',
        description: 'TypeScript, React Native, Javascript, FlutCPAppIconter, Native Script.',
    },
    {
        icon: BackendIcon,
        title: 'Backend Development',
        description: 'Node.js, Ruby on Rails (RoR), Python, Firebase',
    }

];


function Technology(props) {
    return (
        <div className="technoloy_sec p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="">
                        <div className="example" data-text="Tech">
                            <h2>Technologies TekRevol Uses for Software Development In San Francisco</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto offset-xl-1">
                        <p>We utilize a versatile array of robust technologies to address your unique demands.In Android development, we make use of Java, Kotlin, Fastlane, Gradle, Coroutines, Dagger2, and JetPack.  On the iOS front, we utilize SwiftLint, Objective-C, RxSwift, CircleCI, Swift, SwiftUI, and CocoaPods. For crafting hybrid apps, our toolkit encompasses TypeScript, React Native, Javascript, Flutter, and Native Script. When it comes to backend development, we leverage the capabilities of Node.js, Ruby on Rails (RoR), Python, and Firebase.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
                        <div className="technology_main">
                            {StackItem.map((item, index) => (
                                <div className="technology_item">
                                    <div className="svg_icon">
                                        {item.icon}
                                    </div>
                                    <h6>{item.title}</h6>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Technology;